// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotosIcon_root__QtAU4","image":"PhotosIcon_image__2SJ2U","delete":"PhotosIcon_delete__3KUm_"};